// extracted by mini-css-extract-plugin
export default {"modalTitleId":"ModalLabelVersion2_modalTitleId__ga2oe","modalTitleLabel":"ModalLabelVersion2_modalTitleLabel__Z22EL","modalTitleIcon":"ModalLabelVersion2_modalTitleIcon__QWTtC"};